import React, { useEffect, useState } from 'react'
import { withAuth } from '../AuthContext'
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
} from '@paypal/react-paypal-js'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import verifyAccountStatus from '../Hooks/VerifyAccountStatus'
import { setSubscriptionPricing } from '../../utils/utils'
import styled from 'styled-components'

import { Title, GreenBoldSub, ActionButtons } from '../Utils/CustomClasses'
import { scrollIntoView } from '../Hooks/ScrollView'

const ContainerBox = styled.div`
  padding: 30px 36px 15px 36px;
  background-color: #ffffff;
  text-align: center;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const Paypal = (props) => {
  const [loading, setLoading] = React.useState(false)
  const [pageText, setPageText] = useState([])
  const clientId = props.isDev ? paypalDevId : paypalLiveId
  const [membership, setMembership] = useState({
    paypalSubscriptionId: null,
    paypalSubscriptionId10PerDiscount: null,
    paypalSubscriptionId15PerDiscount: null,
    paypalSubscriptionId20PerDiscount: null,
    paypalSubscriptionId25PerDiscount: null,
    paypalSubscriptionId30PerDiscount: null,
    paypalSubscription3MonthsFree: null,
  })

  const initialOptions = {
    clientId,
    currency: props.user.currencyValue,
    intent: 'subscription',
    vault: true,
  }

  const headers = {
    'Content-Type': 'application/json',
  }

  useEffect(() => {
    // SCROLL IN VIEW
    /*
    setTimeout(function () {
      scrollIntoView(props.actionRef)
    }, 1000)
    */

    gaEvents.eventGeneric(
      'page_load',
      'paypal-page-loaded',
      props.user.id + ' - paypal - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getPricing = async () => {
      const membershipData = await setSubscriptionPricing(
        props.subscriptionType,
        props.currencySign,
        'paypal'
      )

      console.log('membershipData: ' + JSON.stringify(membershipData))

      setMembership(membershipData)
    }

    getPageText('profile-paypal', language)
    getPricing()
  }, [])

  function createSubscription(data, actions) {
    if (props.isFromGift !== undefined) {
      gaEvents.eventGeneric(
        'button_click',
        'paypal-payment-actioned',
        props.user.id + ' -(GIFT) Paypal page - button - action Paypal payment'
      )
    } else {
      gaEvents.eventGeneric(
        'button_click',
        'paypal-payment-actioned',
        props.user.id + ' - Paypal page - button - action Paypal payment'
      )
    }

    var paypalPlanId = null

    if (props.discountType !== 'MTH') {
      switch (props.discount) {
        case 10:
          paypalPlanId = membership.paypalSubscriptionId10PerDiscount
          break
        case 15:
          paypalPlanId = membership.paypalSubscriptionId15PerDiscount
          break
        case 20:
          paypalPlanId = membership.paypalSubscriptionId20PerDiscount
          break
        case 25:
          paypalPlanId = membership.paypalSubscriptionId25PerDiscount
          break
        case 30:
          paypalPlanId = membership.paypalSubscriptionId30PerDiscount
          break
        default:
          paypalPlanId = membership.paypalSubscriptionId
      }
    } else {
      switch (props.discount) {
        case 2:
          console.log('its 2')
          paypalPlanId = membership.paypalSubscription2MonthsFree
          break
        default:
          console.log('its not 2')
          paypalPlanId = membership.paypalSubscription3MonthsFree
      }
    }

    console.log('props.discount: ' + props.discount)
    console.log('paypalPlanId: ' + paypalPlanId)

    return actions.subscription
      .create({
        plan_id: paypalPlanId,
      })
      .then((orderID) => {
        const data = {
          orderId: orderID,
        }

        // Hit backend and update user details.
        axios
          .post('/api/create-paypal-order', data, headers)
          .catch(function (error) {
            console.log('error: ' + JSON.stringify(error))
          })

        return orderID
      })
  }

  function onApprove(data, actions) {
    if (data.orderID !== '' && data.orderID !== null) {
      const postData = {
        orderDetails: data,
        subscriptionType: props.subscriptionType,
        membershipFee: props.membershipFee,
        discount: props.discount,
        discountType: props.discountType,
        discountCode: props.discountCode,
      }

      setLoading(true)

      // Hit backend and update user details.
      axios
        .post('/api/confirm-paypal-order', postData, headers)
        .then((response) => {
          verifyAccountStatus(props, 'paypal')

          if (props.isFromGift !== undefined) {
            window.open('/gift-your-grown-up/completed', '_self')
          } else {
            window.open('/onboarding?p=db2', '_self')
          }
        })
        .catch(function (error) {
          console.log('error: ' + JSON.stringify(error))
          setLoading(false)
        })
    }
  }

  function onError(err) {
    console.log('error: ' + err)
  }

  // Custom component to wrap the PayPalButtons and show loading spinner
  const ButtonWrapper = ({ type }) => {
    const [{ isPending, options }, dispatch] = usePayPalScriptReducer()

    useEffect(() => {
      dispatch({
        type: 'resetOptions',
        value: {
          ...options,
          intent: 'subscription',
        },
      })
    }, [type])

    return (
      <div>
        {isPending && <div className="spinner" />}
        <PayPalButtons
          createSubscription={createSubscription}
          onApprove={onApprove}
          onError={onError}
        />
      </div>
    )
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[2]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox ref={props.actionRef}>
      <Title
        size="29px"
        sizemd="29px"
        sizesm="24px"
        margin="0 0 20px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[0]}`,
        }}
      ></Title>
      <GreenBoldSub
        size="18px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[1]}`,
        }}
      ></GreenBoldSub>
      <img
        src="/images/profile/secured-by-paypal.png"
        alt=""
        className="img-secured-by-stripe"
      />
      <PayPalScriptProvider options={initialOptions}>
        <ButtonWrapper type="subscription" />
      </PayPalScriptProvider>
    </ContainerBox>
  )
}

export default withAuth(Paypal)
